import { ETypeMenuFooter } from 'components/Layout/components/footer/Footer';
import API from 'libs/axios';

export const getTerms = (category: ETypeMenuFooter) =>
  API.get(`/terms?platform=ADMIN_SYS&category=${category}`);

export const getSupport = () => API.get('/support_url');
